const ResultsNumEnum = Object.freeze({
  Čeština: 'Počet výsledků',
  Deutsch: 'Anzahl der Ergebnisse',
  Français: 'Nombre de résultats',
  Slovenčina: 'Počet výsledkov',
  Español: 'Número de resultados',
  English: 'Number Of Results',
})

export default ResultsNumEnum
